import Axios from 'axios';
import { BASE_URL } from './urls';

const axiosInstance = Axios.create({
  baseURL: BASE_URL,
  headers: {
    Authorization:
      localStorage.getItem('token') && localStorage.getItem('token') !== null
        ? `bearer ${(localStorage.getItem('token') || '')
            .replaceAll('"', '')
            .toString()}`
        : '',
  },
});

export default axiosInstance;
